import { jsx as _jsx } from "react/jsx-runtime";
import { UploadContext } from "@air/component-upload-dropzone";
import { Uploads as UploadIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo, useCallback, useContext } from "react";
import { ACTION_BAR_UPLOAD } from "~/constants/testIDs";
export const BoardCollectionUploadMoreButton = /*#__PURE__*/ memo(()=>{
    const { isAboveMediumScreen } = useBreakpointsContext();
    const { openUploader } = useContext(UploadContext);
    const _openUploader = useCallback(()=>{
        openUploader();
    }, [
        openUploader
    ]);
    if (isAboveMediumScreen) {
        return /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            size: "large",
            prefix: /*#__PURE__*/ _jsx(UploadIcon, {
                className: "size-4"
            }),
            onClick: _openUploader,
            "data-testid": ACTION_BAR_UPLOAD,
            children: "Upload"
        });
    }
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        color: "grey",
        size: "large",
        icon: UploadIcon,
        className: "mr-2",
        label: "Upload",
        onClick: _openUploader,
        "data-testid": ACTION_BAR_UPLOAD
    });
});
BoardCollectionUploadMoreButton.displayName = "BoardCollectionUploadMoreButton";
